module.exports = __webpack_public_path__ + "272dde15e57b3c8ce66a5560d6e73dcd.svg";